<template>
  <section class="section-base form-section-base">
    <div class="form-section-base__title">
      Сведения о кредиторе (если кредиторов несколько, раздел заполняется в
      отношении каждого кредитора)
    </div>

    <v-container>
      <div class="form-base">
        <v-checkbox
          v-model="isCreditors"
          label="Заполнить сведения о кредиторах"
          hide-details
        />

        <div v-if="isCreditors" class="pb-5">
          <Creditor
            v-for="(v, index) in $v.creditors.$each.$iter"
            :key="index"
            @delete="deleteCreditor(index)"
            :v="v"
            :can-delete="creditors.length > 1"
            class="creditor"
          />

          <v-btn
            depressed
            color="primary"
            class="button-base"
            @click="addCreditor"
          >
            <v-icon size="20" left>{{ mdiAccountMultiplePlus }}</v-icon>
            Добавить кредитора
          </v-btn>
        </div>

        <Footer
          @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
          @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
          :loading-next="loadingNext"
          class="pt-6"
        />
      </div>
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';
import deepmerge from 'deepmerge';
import { mdiAccountMultiplePlus } from '@mdi/js';
import { getValidationErrorText } from '@/utils/validate';
import { Role } from '@/utils/dictionaries';
import Footer from '@/components/services/elements/Footer';
import { checkInvalid, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import { StepDirection, StepName } from '@/types/services';
import Creditor, { creditorModel, creditorValidation } from './Creditor';
import { AcceptanceDepositStep } from '@/constants';

export default {
  name: 'Creditors',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Creditor,
    Footer,
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    Role,
    mdiAccountMultiplePlus,
    getValidationErrorText,
    isCreditors: false,
    invalidFields: [],
    creditors: [cloneDeep(creditorModel)],
  }),
  validations() {
    return {
      creditors: {
        $each: creditorValidation,
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      if (!ServicesModule.statement.subjects.creditors?.length) return;

      this.isCreditors = true;
      this.creditors = ServicesModule.statement.subjects.creditors.map(
        (statementCreditor) => {
          const model = {};

          if (statementCreditor[Role.PERSON]) {
            model.role = Role.PERSON;
            model[Role.PERSON] = statementCreditor[Role.PERSON];
          }

          if (statementCreditor[Role.ORGANIZATION]) {
            model.role = Role.ORGANIZATION;
            model[Role.ORGANIZATION] = statementCreditor[Role.ORGANIZATION];
          }

          if (statementCreditor[Role.FOREIGN_ORGANIZATION]) {
            model.role = Role.FOREIGN_ORGANIZATION;
            model[Role.FOREIGN_ORGANIZATION] =
              statementCreditor[Role.FOREIGN_ORGANIZATION];
          }

          model.details = cloneDeep(statementCreditor.details);

          return deepmerge(creditorModel, model);
        }
      );
    },

    addCreditor() {
      this.creditors.push(cloneDeep(creditorModel));
    },

    deleteCreditor(index) {
      this.creditors = this.creditors.filter((_, i) => i !== Number(index));
    },

    touchFields() {
      this.invalidFields = [];

      if (!this.isCreditors) return;

      for (const creditor of Object.values(this.$v.creditors.$each.$iter)) {
        creditor[creditor.role.$model].$touch();
        checkInvalid(creditor[creditor.role.$model], this.invalidFields);

        creditor.details.$touch();
        checkInvalid(creditor.details, this.invalidFields);
      }
    },

    getNoCreditorsDepositAmount() {
      const storeDepositAmount =
        ServicesModule.statement.acceptanceDepositDetails?.depositAmount;
      const storeIsCreditors = Boolean(
        ServicesModule.statement.subjects.creditors?.length
      );

      if (storeIsCreditors) return null;

      return storeDepositAmount;
    },

    assemblyModel() {
      const model = {
        creditors: [],
        acceptanceDepositDetails: {},
      };

      if (!this.isCreditors) {
        model.acceptanceDepositDetails = {
          depositCurrency: 'RUB',
          depositAmount: this.getNoCreditorsDepositAmount(),
        };

        return model;
      }

      model.creditors = this.creditors.map((creditor) => {
        return {
          [creditor.role]: cloneDeep(creditor[creditor.role]),
          details: cloneDeep(creditor.details),
        };
      });

      const depositAmount = model.creditors.reduce(
        (prevValue, nextCreditor) =>
          prevValue + Number(nextCreditor.details.depositAmount),
        0
      );

      model.acceptanceDepositDetails = {
        depositCurrency: 'RUB',
        depositAmount,
      };

      return model;
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: AcceptanceDepositStep.CREDITORS,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.creditor {
  &:not(:first-child) {
    margin-bottom: 40px;
  }
}
</style>
